/* eslint no-magic-numbers: "off" */
import { exists } from '@engine/lib/utility/exists';
import { toggleDisabledAttribute } from '@engine/lib/utility/toggle_disabled_attribute';

function updateManagedRecurringFields(attr) {
  toggleDisabledAttribute($('#managed_recurring_params .form-control'), attr);
}

export function attachDatePickers() {
  var $datetimepickers_date = $('.datetimepicker-date');
  var $datetimepickers_time = $('.datetimepicker-time');

  if (exists($datetimepickers_date)) {
    $datetimepickers_date.datetimepicker({
      format: 'YYYY-MM-DD',
      locale: moment.locale(I18n.locale)
    });
  }

  if (exists($datetimepickers_time)) {
    $datetimepickers_time.datetimepicker({
      format: 'H',
      locale: moment.locale(I18n.locale)
    });
  }
}
export function listenForIntervalChange() {
  var $intervalSelect = $('#managed_recurring_item_interval');

  if (exists($intervalSelect)) {
    var $periodSelect = $('#managed_recurring_item_period');
    var minPeriod = $periodSelect.attr('data-min-period');
    $($intervalSelect).on('change', function () {
      var selectedInterval = $(this).val();
      var maxPeriod = $periodSelect.attr("data-max-period-for-".concat(selectedInterval));
      $periodSelect.empty();
      var periodSelectNumbers = Array(parseInt(maxPeriod, 10)).fill(parseInt(minPeriod, 10)).map(function (x, y) {
        return x + y;
      });
      periodSelectNumbers.forEach(function (number) {
        var option = $('<option/>').attr('value', number).text(number);
        $periodSelect.append(option);
      });
      $periodSelect.trigger('chosen:updated');
    });
  }
}
export function listenForAddManagedRecurringChange() {
  $('#configure_new_managed_recurring').on('change', function () {
    if ($(this).is(':checked')) {
      $('#managed_recurring_params').removeClass('hidden');
      updateManagedRecurringFields(false);
      $('#managed_recurring_params .for_chosen').trigger('chosen:updated');
    } else {
      $('#managed_recurring_params').addClass('hidden');
      updateManagedRecurringFields(true);
      $('#managed_recurring_params .for_chosen').trigger('chosen:updated');
    }
  });
}